import {
  accentFor,
  apkHref,
  hasApk,
  hasWeb,
  iconClickHref,
  iconGlyph,
} from '../display';
import { fetchModules, type SiteModule } from '../modules';

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function tile(mod: SiteModule, index: number): string {
  const href = iconClickHref(mod);
  const glyph = escapeHtml(iconGlyph(mod.name));
  const name = escapeHtml(mod.name);
  const tip = escapeHtml(mod.summary);
  const color = accentFor(index);
  const iconTag = href
    ? `<a class="icon" href="${escapeHtml(href)}"${hasWeb(mod) ? ' target="_blank" rel="noopener noreferrer"' : ' download'} style="background:${color}" aria-label="${name}">${glyph}</a>`
    : `<span class="icon" style="background:${color}" aria-hidden="true">${glyph}</span>`;

  const tags: string[] = [];
  if (hasWeb(mod)) {
    tags.push(
      `<a class="tag" href="${escapeHtml(mod.webUrl.trim())}" target="_blank" rel="noopener noreferrer">网页</a>`,
    );
  }
  if (hasApk(mod)) {
    tags.push(
      `<a class="tag tag-apk" href="${escapeHtml(apkHref(mod.apkName))}" download="${escapeHtml(`${mod.name.trim()}.apk`)}">APP</a>`,
    );
  }

  return `
    <article class="tile" title="${tip}">
      ${iconTag}
      <div class="name">${name}</div>
      <div class="tags">${tags.join('')}</div>
    </article>`;
}

export async function renderHome(root: HTMLElement): Promise<void> {
  document.title = '小站工坊';
  try {
    const list = await fetchModules();
    root.innerHTML = `
      <div class="workshop">
        <header>
          <h1>小站工坊</h1>
        </header>
        <div class="dock">${list.map((m, i) => tile(m, i)).join('')}</div>
      </div>`;
  } catch {
    root.innerHTML = `
      <div class="workshop">
        <header>
          <h1>小站工坊</h1>
        </header>
        <p class="error">暂时无法加载模块</p>
      </div>`;
  }
}
